import {callApi} from '../api'

export const GET_PROJECTS = 'GET_PROJECTS';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';

export function getProjects(cb) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'GET', '/projects', null, GET_PROJECTS, cb);
    }
}

export function updateProject(cb, projectId, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'PATCH', '/projects/' + projectId, data, UPDATE_PROJECT, cb);
    }
}

export function createProject(cb, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'POST', '/projects', data, CREATE_PROJECT, cb);
    }
}

export function deleteProject(cb, projectId, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'DELETE', '/projects/' + projectId, null, DELETE_PROJECT, cb);
    }
}



// WEBPACK FOOTER //
// ./src/actions/projects.js